(() => {
  const heroSelector = '[data-nosht-deferred-hero]';

  if (window.NoshtDeferredHero) {
    window.NoshtDeferredHero.init(document);
    return;
  }

  const hydrateImage = (image) => {
    if (!image || image.dataset.noshtHydrated === 'true') return;

    const picture = image.closest('picture');
    picture?.querySelectorAll('source[data-srcset]').forEach((source) => {
      source.srcset = source.dataset.srcset;
      source.removeAttribute('data-srcset');
    });

    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    }

    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
    }

    image.dataset.noshtHydrated = 'true';
    image.removeAttribute('data-nosht-deferred-image');
  };

  const initHero = (hero) => {
    if (hero.dataset.noshtDeferredHeroReady === 'true') return;
    hero.dataset.noshtDeferredHeroReady = 'true';

    const deferredImages = Array.from(hero.querySelectorAll('img[data-nosht-deferred-image]'));
    if (deferredImages.length === 0) return;

    let hydrationQueued = false;
    const hydrateAll = () => {
      hydrationQueued = true;
      deferredImages.forEach(hydrateImage);
    };
    const queueHydration = () => {
      if (hydrationQueued) return;
      hydrationQueued = true;

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(hydrateAll, { timeout: 1200 });
      } else {
        window.setTimeout(hydrateAll, 300);
      }
    };

    const firstImage = hero.querySelector('.hero--slideshow img:not([data-nosht-deferred-image])');

    const queueAfterDecode = () => {
      if (firstImage?.decode) {
        firstImage.decode().catch(() => {}).finally(queueHydration);
      } else {
        queueHydration();
      }
    };

    if (!firstImage || firstImage.complete) {
      queueAfterDecode();
    } else {
      firstImage.addEventListener('load', queueAfterDecode, { once: true });
      firstImage.addEventListener('error', queueHydration, { once: true });
    }

    ['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach((eventName) => {
      hero.addEventListener(eventName, hydrateAll, { once: true, passive: eventName !== 'keydown' });
    });
  };

  const init = (root = document) => {
    const heroes = root.matches?.(heroSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(heroSelector) || []);

    heroes.forEach(initHero);
  };

  window.NoshtDeferredHero = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
